<template>
  <button
    :type="type"
    :class="classes"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <span
      v-if="loading"
      class="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
      aria-hidden="true"
    />
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Variant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
type Size = 'sm' | 'md' | 'lg'

const props = withDefaults(
  defineProps<{
    variant?: Variant
    size?: Size
    block?: boolean
    loading?: boolean
    disabled?: boolean
    type?: 'button' | 'submit'
  }>(),
  { variant: 'primary', size: 'md', type: 'button' },
)

defineEmits<{ click: [MouseEvent] }>()

// 터치 타깃 최소 44px (Plan 접근성 기준)
const SIZE_CLASS: Record<Size, string> = {
  sm: 'h-11 px-3 text-[13px]',
  md: 'h-12 px-4 text-[15px]',
  lg: 'h-14 px-5 text-[16px]',
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'bg-primary text-on-primary',
  secondary: 'bg-secondary text-on-secondary',
  outline: 'bg-surface text-text border border-border',
  ghost: 'bg-transparent text-text',
  danger: 'bg-danger text-white',
}

const classes = computed(() => [
  'inline-flex items-center justify-center gap-1.5 rounded-[var(--radius-md)] font-bold',
  'transition-opacity active:opacity-80',
  'disabled:opacity-40 disabled:pointer-events-none',
  SIZE_CLASS[props.size],
  VARIANT_CLASS[props.variant],
  props.block ? 'w-full' : '',
])
</script>
